/** Compact flag glyphs for the header language toggle — SVG for consistent rendering across OS. */

export function LangFlagRo({ className }) {
  return (
    <svg className={className} viewBox="0 0 3 2" aria-hidden="true">
      <rect width="1" height="2" fill="#002B7F" />
      <rect x="1" width="1" height="2" fill="#FCD116" />
      <rect x="2" width="1" height="2" fill="#CE1126" />
    </svg>
  );
}

/** Union Jack — UK; uzual în RO pentru opțiunea „English” */
export function LangFlagUk({ className }) {
  return (
    <svg className={className} viewBox="0 0 64 32" aria-hidden="true">
      <path fill="#012169" d="M0 0h64v32H0z" />
      <path stroke="#FFFFFF" strokeWidth="7" d="M0 0l64 32M64 0L0 32" />
      <path stroke="#C8102E" strokeWidth="4" d="M0 0l64 32M64 0L0 32" />
      <path stroke="#FFFFFF" strokeWidth="12" d="M32 0v32M0 16h64" />
      <path stroke="#C8102E" strokeWidth="8" d="M32 0v32M0 16h64" />
    </svg>
  );
}

export function LangFlagUa({ className }) {
  return (
    <svg className={className} viewBox="0 0 3 2" aria-hidden="true">
      <rect width="3" height="1" fill="#005BBB" />
      <rect y="1" width="3" height="1" fill="#FFD500" />
    </svg>
  );
}

/** Uniform chip around flags inside bordered controls */
export function LangFlagChip({ children }) {
  return (
    <span className="relative inline-flex h-[14px] w-[21px] shrink-0 overflow-hidden rounded-[3px] bg-white shadow-[inset_0_0_0_1px_rgba(15,23,42,0.12)] [&_svg]:block [&_svg]:h-full [&_svg]:w-full">
      {children}
    </span>
  );
}
